import { useEffect, useState } from 'react';

import {
  DepositCryptoMethodsResponse,
  DepositCryptoOption,
  useGetDepositCryptoMethods,
  useUpdateDepositCryptoMethods
} from 'react-easyrocket';
import { CryptochillMethodsReturnType } from '../types';
import { useTranslation } from 'react-i18next';

export const useCryptochill = (): CryptochillMethodsReturnType => {
  const {
    i18n: { language }
  } = useTranslation();
  const { data, isLoading, isFetching } = useGetDepositCryptoMethods(undefined, {
    onSuccess: ({ data }) => {
      const options = prepareOptions(data);
      setOptions(options);
      if (!selectedMethod) {
        setSelectedMethod(findUsdt(options));
      }
    }
  });
  const [options, setOptions] = useState(() => {
    return prepareOptions(data);
  });
  const [selectedMethod, setSelectedMethod] = useState<DepositCryptoOption | undefined>(
    findUsdt(options)
  );
  const { mutateAsync: getMethodsWithAddress, isPending } = useUpdateDepositCryptoMethods();

  /** Ф-ия выбора платежного метода cryptochill */
  const handleCryptoMethodSelect = (cryptoMethod: DepositCryptoOption) => {
    setSelectedMethod(cryptoMethod);
  };

  useEffect(() => {
    if (!selectedMethod) return;
    if (!selectedMethod?.account) {
      (async () => {
        const response = await getMethodsWithAddress({
          language,
          get_address: selectedMethod.name
        });
        const options = prepareOptions(response.data);
        const currentMethod = options.find((method) => method.name === selectedMethod.name);
        if (!currentMethod) return;
        setOptions(options);
        setSelectedMethod(currentMethod);
      })();
    }
  }, [selectedMethod?.name]);

  return {
    cryptoMethods: [...options].sort((el) => (el.name === 'USDTTRC20' ? -1 : 1)),
    isLoadingCryptoMethods: isLoading,
    selectedCryptoMethod: selectedMethod,
    isFetchingMissingAddress: !selectedMethod?.account && (isPending || isFetching),
    handleCryptoMethodSelect
  };
};

function findUsdt(options: DepositCryptoOption[]) {
  return options.find((el) => el.name === 'USDTTRC20');
}

function prepareOptions(data: DepositCryptoMethodsResponse | undefined) {
  return Array.isArray(data) ? [] : data?.options || [];
}
